<template>
  <div class="corp-expired">
    <div class="corp-expired__card">
      <v-icon size="44" color="error" class="mb-3">mdi-calendar-alert</v-icon>
      <h1 class="font-lg mb-2">Срок кабинета истёк</h1>
      <div v-if="activity && activity.untilText" class="grey--text text--darken-1 mb-4">
        Срок действия закончился {{ activity.untilText }}.
      </div>
      <p class="mb-2">
        Управление менеджерами и кандидатами, назначение тестов и распределение остатков временно недоступны.
      </p>
      <p class="mb-6">
        Чтобы продлить кабинет, оформите заказ в каталоге услуг. Как только администратор подтвердит оплату, доступ восстановится автоматически.
      </p>

      <v-alert v-if="checkFailed" type="warning" dense outlined class="text-left">
        Не удалось получить данные с сервера. Проверьте соединение и попробуйте ещё раз.
      </v-alert>
      <v-alert v-else-if="stillExpired" type="info" dense outlined class="text-left">
        Срок пока не обновлён. Если вы уже оплатили заказ, дождитесь подтверждения администратора и проверьте статус ещё раз.
      </v-alert>

      <div class="d-flex flex-wrap justify-center" style="gap: 12px">
        <v-btn color="primary" :to="{ name: 'list-services' }">Продлить в каталоге</v-btn>
        <v-btn outlined color="primary" :to="{ name: 'my-orders' }">Мои заказы</v-btn>
        <v-btn text color="primary" :loading="checking" @click="check">Проверить статус</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { parseCorpActivity } from '@/common/models/corpActivity';

// Экран истёкшего кабинета корпа (ограниченный режим). Состояние берём только от сервера (get-me).
export default {
  name: 'CorpExpiredPage',
  data: () => ({
    checking: false,
    stillExpired: false,
    checkFailed: false,
  }),
  computed: {
    ...mapGetters({ user: 'auth/user' }),
    activity() {
      return parseCorpActivity(this.user);
    },
  },
  methods: {
    ...mapActions({ refreshMe: 'auth/refreshMe' }),
    async check() {
      this.checking = true;
      this.stillExpired = false;
      this.checkFailed = false;
      try {
        const ok = await this.refreshMe();
        this.checkFailed = !ok;
        // Если сервер вернул active, страница профиля сама заменится обычным кабинетом
        this.stillExpired = ok && !!this.activity && this.activity.isExpired;
      } finally {
        this.checking = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.corp-expired {
  display: flex;
  justify-content: center;
  padding: 48px 16px;

  &__card {
    max-width: 560px;
    width: 100%;
    padding: 32px 24px;
    text-align: center;
    border: 1px solid #ececec;
    border-radius: 12px;
    background: #fff;
  }
}
</style>
